<template>
  <div id="app">
    <router-view/>
    <notifications position="bottom right" width="50%" />
    <v-dialog/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  margin: 90px 0 50px;

  @media (min-width: 768px)  {
    margin-top: 40px;
  }

  @media(min-width: 1200px) {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue